module.exports = __webpack_public_path__ + "img/world.east.c716d99c.svg";